import Image from 'next/image';
import Link from 'next/link';

import { MediaQuery, useMediaQuery } from '../../../hooks/useMediaQuery';

type FeaturedCardProps = {
  ctaLink: string;
  src: string;
  subtitle?: string;
  title: string;
};

export function FeaturedCard(props: FeaturedCardProps) {
  const { ctaLink, src, subtitle, title } = props;

  const isDesktop = useMediaQuery(MediaQuery.LG);
  const imageHeight = isDesktop ? 70 : 60;
  const imageWidth = isDesktop ? 140 : 100;

  const subtitleContent = subtitle ? (
    <p className="text-caption sm:text-[11px] font-MuseoSans100 font-extralight leading-3 mt-1">
      {subtitle}
    </p>
  ) : (
    ''
  );

  return (
    <div className="flex items-center">
      <div className="block min-w-fit">
        <Image
          alt={title}
          blurDataURL="/icons/blur-placeholder.png"
          height={imageHeight}
          objectFit="cover"
          placeholder="blur"
          src={src}
          width={imageWidth}
        />
      </div>
      <Link href={ctaLink} passHref>
        <a
          className="ml-2 text-[14px] sm:text-subtitle font-MuseoSans300 font-bold"
          target="_self"
        >
          <p className="font-MuseoSans300 leading-4">{title}</p>
          {subtitleContent}
        </a>
      </Link>
    </div>
  );
}

export default FeaturedCard;
